import BN from 'bn.js';
export const calculateReceivedToken = (amountBusd, pricePerToken) => {
  const busdBN = new BN(amountBusd.value);
  const pricePerTokenBN = new BN(pricePerToken.value);
  return busdBN.div(pricePerTokenBN);
};